interface StorageWrapperInterface {
    storage: Storage
}

function getIsStorageAvailable(): boolean {
    if (typeof window === "undefined") return false
    try {
        const test = "isStorageAvailable"
        window.localStorage.setItem(test, test)
        window.localStorage.removeItem(test)
        return true
    } catch {
        return false
    }
}

export const isStorageAvailable: boolean =
    typeof window !== "undefined" ? getIsStorageAvailable() : false

export function safeSetItem(storage: Storage | undefined, key: string, value: string): boolean {
    try {
        storage?.setItem(key, value)
        return true
    } catch {
        return false
    }
}

export class StorageWrapper implements StorageWrapperInterface {
    storage: Storage

    constructor(storage: Storage) {
        this.storage = storage
    }

    remove(key: string) {
        if (!this.storage) return
        this.storage.removeItem(key)
    }

    get<T>(key: string): T | undefined {
        const str = this.storage.getItem(key)
        return str ? (JSON.parse(str) as T) : undefined
    }

    getInt(key: string): number {
        if (!this.storage) return 0
        return this.get<number>(key) || 0
    }

    getString<T>(key: string): T | undefined {
        if (!this.storage) return undefined
        return (this.storage.getItem(key) as T) || undefined
    }

    getObject<T>(key: string): T | undefined {
        if (!this.storage) return undefined
        return this.get<T>(key)
    }

    getArray<T>(key: string): T[] | undefined {
        if (!this.storage) return undefined
        return this.get<T[]>(key) || undefined
    }

    store(key: string, value: unknown) {
        if (!this.storage) return
        return safeSetItem(
            this.storage,
            key,
            typeof value === "string" ? value : JSON.stringify(value)
        )
    }

    storeInt(key: string, value: number) {
        return this.store(key, value || 0)
    }

    storeString(key: string, value: string) {
        return this.store(key, value || "")
    }

    storeObject(key: string, value: object) {
        return this.store(key, value || {})
    }

    storeArray(key: string, value: unknown) {
        return this.store(key, value || [])
    }
}
